import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, flatten, mapMany, intersect, union } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PaquetesPPPorClienteComp } from "./clientecomp";

interface Props {
    sugerencias: models.ContrareciboSugeridoModel[];
    /**Folios de las guias seleccionadas */
    paquetespp: number[];
    onSeleccionar: (x: number[]) => void;
}

/**Obtiene las guias seleccionadas de un cliente*/
function getSeleccion(sugerencias: models.ContrareciboSugeridoModel[], guias: number[], idCliente: number): number[] {
    //Folios de las guias de ese cliente
    const gCliente =
        mapMany(sugerencias.filter(x => x.IdCliente == idCliente), x => x.Paquetes).map(x => x.IdPaquetePP);

    return intersect(gCliente, guias);
}

/**Devuelve la nueva seleccion completa despues de haber sido cambiada la seleccion de un cliente */
function updateSeleccion(sugerencias: models.ContrareciboSugeridoModel[], todasGuias: number[], guiasCliente: number[], idCliente: number): number[] {
    //Folios seleccionados de los demas clientes
    const gOtrosClientes =
        intersect(
            mapMany(sugerencias.filter(x => x.IdCliente != idCliente), x => x.Paquetes).map(x => x.IdPaquetePP),
            todasGuias
        );
    return union(gOtrosClientes, guiasCliente);
}

/**Componente que selecciona un conjunto de guias agrupadas por cliente */
export class MulticlienteSugerenciaComp extends React.PureComponent<Props> {
    onSeleccionar = (paquetesCliente: number[], idCliente: number) => {
        const newSeleccion = updateSeleccion(this.props.sugerencias, this.props.paquetespp, paquetesCliente, idCliente);
        this.props.onSeleccionar(newSeleccion);
    }

    render() {
        return (
            <div>
                {
                    this.props.sugerencias.map(x =>
                        <PaquetesPPPorClienteComp
                            paquetespp={getSeleccion(this.props.sugerencias, this.props.paquetespp, x.IdCliente)}
                            sugerencia={x}
                            onSeleccionar={guiasCliente => this.onSeleccionar(guiasCliente, x.IdCliente)}
                        />)
                }
                {
                    this.props.sugerencias.length == 0 &&
                    <div className="alert alert-info">
                        No hay paquetes de prepago
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibospp/multiclientecomp.tsx